import React, { useState, useEffect, useRef } from 'react';
import { useTranslation } from 'react-i18next';

const LimitOptions = (props) => {
	const { t, i18n } = useTranslation();

	const {form_component} = props;

	return (
		<span className="mx-1" data-limit={`max-${form_component.max_options}`}>{form_component.max_options}</span>
	);
}

export default LimitOptions;